import { useEffect } from "react";
import { useNavigate, Outlet, NavLink as RouterNavLink } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Package, LogOut, Loader2 } from "lucide-react";

export function AdminLayout() {
  const navigate = useNavigate();
  const { user, isAdmin, adminChecked, signOut } = useAuth();

  useEffect(() => {
    // Wait for admin check to complete before redirecting
    if (!adminChecked) return;
    
    if (!user) {
      navigate("/admin/login", { replace: true });
    } else if (!isAdmin) {
      navigate("/", { replace: true });
    }
  }, [user, isAdmin, adminChecked, navigate]);

  const handleLogout = async () => {
    await signOut();
    navigate("/admin/login", { replace: true });
  };

  // Show loading while checking auth state
  if (!adminChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // Don't render until we confirm user is admin
  if (!user || !isAdmin) {
    return null;
  }

  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <aside className="w-64 bg-card border-r flex flex-col">
        <div className="p-6 border-b">
          <h1 className="text-xl font-bold font-playfair">Admin Panel</h1>
          <p className="text-sm text-muted-foreground">idacoromania.ro</p>
        </div>

        <nav className="flex-1 p-4 space-y-2">
          <RouterNavLink
            to="/admin/dashboard"
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${
                isActive
                  ? "bg-primary text-primary-foreground"
                  : "hover:bg-muted"
              }`
            }
          >
            <Package className="h-5 w-5" />
            <span>Products</span>
          </RouterNavLink>
        </nav>

        <div className="p-4 border-t">
          <Button
            variant="outline"
            className="w-full justify-start"
            onClick={handleLogout}
          >
            <LogOut className="h-5 w-5 mr-3" />
            Logout
          </Button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
